import Chip from '@/components/ui/Chip';

type Props = {
  value: boolean;
};

const MachineLoadStatus = ({ value }: Props) => (
  <Chip
    color={value ? 'error' : 'success'}
    label={value ? 'Low' : 'Ok'}
    sx={{ mx: 'auto', fontWeight: 'bold', fontSize: '12px' }}
  />
);

export default MachineLoadStatus;
